var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConflictAlreadyPaid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#conflictAlreadyPaid_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.152 53.803a2.476 2.476 0 003.033 1.75l33.485-8.972a2.476 2.476 0 001.751-3.033l-5.768-21.526a2.476 2.476 0 00-3.032-1.751l-33.486 8.972a2.476 2.476 0 00-1.75 3.033l5.767 21.526z",
    fill: "#C7DFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39.619,
    height: 27.238,
    rx: 2.476,
    transform: "scale(1 -1) rotate(15 210.443 64.91)",
    fill: "#F399AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.822 29.857c1.465.846 3.607 5.619 3.607 5.619s-5.205.53-6.67-.315a3.062 3.062 0 013.063-5.304zM34.774 28.53c-.846 1.464-.315 6.669-.315 6.669s4.774-2.143 5.62-3.607a3.062 3.062 0 00-5.305-3.063z",
    fill: "#FFD368"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.432 50.103a3.405 3.405 0 004.17 2.408l33.486-8.973a3.405 3.405 0 002.407-4.17l-5.768-21.526a3.405 3.405 0 00-4.17-2.407l-33.485 8.972a3.405 3.405 0 00-2.408 4.17l5.768 21.526zm3.69.614a1.548 1.548 0 01-1.896-1.094l-5.768-21.527a1.548 1.548 0 011.095-1.895l33.485-8.973a1.548 1.548 0 011.896 1.095l5.768 21.526a1.548 1.548 0 01-1.095 1.896l-33.485 8.972z",
    fill: "#3B4142"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.945 54.657a1.548 1.548 0 01-1.895-1.095l-.801-2.99-1.794.481.801 2.99a3.405 3.405 0 004.17 2.407l12.557-3.364a.929.929 0 10-.48-1.794l-12.558 3.364zm20.272-4.471a.929.929 0 001.137.657l12.557-3.365a3.405 3.405 0 002.408-4.17l-5.768-21.526a3.405 3.405 0 00-4.17-2.408l-2.99.801.48 1.794 2.99-.801a1.548 1.548 0 011.896 1.094l5.768 21.527a1.548 1.548 0 01-1.094 1.895L53.874 49.05a.929.929 0 00-.657 1.137z",
    fill: "#3B4142"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.035 30.041l-38.27 10.255-.48-1.794 38.27-10.254.48 1.793z",
    fill: "#3B4142"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.826 48.81l-7.05-26.31 1.794-.48 7.05 26.31-1.794.48z",
    fill: "#3B4142"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.919 39.114a.929.929 0 01-.657 1.137l-.24-.896.24.896h-.002l-.002.002-.007.001-.019.005a4.16 4.16 0 01-.268.059 7.75 7.75 0 01-.716.102 7.774 7.774 0 01-2.283-.108c-.884-.18-1.85-.563-2.705-1.314l-.134-.121a5.875 5.875 0 01-.055.172c-.364 1.078-1.01 1.892-1.685 2.49a7.773 7.773 0 01-1.924 1.235 7.803 7.803 0 01-.873.335 3.055 3.055 0 01-.06.018l-.019.005-.006.002H30.5s-.002.001-.242-.896l.24.897a.928.928 0 01-.482-1.793l.032-.01a5.934 5.934 0 00.644-.249 5.922 5.922 0 001.46-.933c.491-.435.92-.99 1.159-1.696.237-.7.308-1.61-.01-2.799l1.794-.48c.318 1.188.836 1.94 1.39 2.428.56.492 1.21.758 1.851.89a5.918 5.918 0 001.732.078 5.933 5.933 0 00.682-.106l.032-.008",
    fill: "#3B4142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.712 39.642a.929.929 0 11-1.794.48.929.929 0 011.794-.48zM50.825 50.827a.929.929 0 11-1.793.48.929.929 0 011.793-.48zM56.094 38.2a.929.929 0 11-1.794.48.929.929 0 011.794-.48z",
    fill: "#3B4142"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.442 31.442a2.134 2.134 0 00.781 2.915c.18.104.605.218 1.288.286.643.064 1.39.077 2.115.064.493-.01.967-.03 1.378-.054a34.868 34.868 0 00-.642-1.22 18.72 18.72 0 00-1.113-1.8c-.401-.557-.712-.868-.892-.972a2.134 2.134 0 00-2.915.781zm6.986 4.033l.094.924h-.005l-.012.002-.047.005-.174.016a38.445 38.445 0 01-2.624.142c-.76.014-1.588.001-2.333-.073-.705-.07-1.48-.207-2.033-.526a3.99 3.99 0 013.991-6.912c.552.318 1.059.922 1.472 1.497.437.608.862 1.319 1.23 1.984a38.363 38.363 0 011.262 2.502l.02.043.004.011.002.005-.847.38zm0 0l.847-.38.527 1.174-1.28.13-.094-.924z",
    fill: "#3B4142"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.493 28.213c1.021.59 1.37 1.894.782 2.915-.105.18-.415.49-.973.891a18.74 18.74 0 01-1.8 1.113c-.431.24-.852.458-1.22.642a34.85 34.85 0 01-.053-1.377c-.014-.725 0-1.472.064-2.115.068-.683.182-1.108.286-1.288a2.134 2.134 0 012.914-.781zm-4.033 6.986l.38.847.005-.002.011-.005.043-.02.16-.073a38.3 38.3 0 002.344-1.189 20.556 20.556 0 001.983-1.23c.575-.413 1.178-.919 1.497-1.47a3.99 3.99 0 10-6.913-3.992c-.318.552-.455 1.328-.525 2.032a20.532 20.532 0 00-.073 2.334 38.228 38.228 0 00.158 2.798l.004.047.002.012v.005l.924-.094zm0 0l-.924.094.13 1.28 1.174-.527-.38-.847z",
    fill: "#3B4142"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.53 37.252l-4.923 1.32M16.733 43.976L2.018 47.919M17.5 51.888l-9.596 2.571",
    stroke: "#3B4142",
    strokeWidth: 2.614,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "conflictAlreadyPaid_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h72v72H0z"
  })))));
}

export default SvgConflictAlreadyPaid;